var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasNotifications)?_c('div',{attrs:{"id":"global-notification"}},_vm._l((_vm.notificationList),function(item){return _c('div',{key:item.id},[_c('b-alert',{attrs:{"show":"","variant":item.Level}},[_c('h3',[_vm._v(_vm._s(item.Titel))]),_c('vue-simple-markdown',{attrs:{"source":item.Message.replaceAll('\\', '')}})],1)],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }